module.exports = __webpack_public_path__ + "assets/img/rccg.1c4bd033.png";